import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import BranchSwitcher from './BranchSwitcher';
import './topbar.css';

const initialsOf = (first, last) => `${(first || '').charAt(0)}${(last || '').charAt(0)}`.toUpperCase() || '?';

function Topbar() {
  const { userDetails, isAdmin, isMerchant } = useAuth();
  const firstName = userDetails?.first_name || '';
  const lastName = userDetails?.last_name || '';
  const fullName = isMerchant
    ? (userDetails?.email || 'Merchant')
    : (`${firstName} ${lastName}`.trim() || 'Account');

  return (
    <header className='topbar'>
      <div className='topbar-wrapper'>
        <div className='topbar-brand'>
          <span className='topbar-logo-mark' aria-hidden='true'>GTI</span>
          <span className='topbar-logo-word'>Microfinance</span>
        </div>
        <BranchSwitcher />
        <Link to='/profile' className='topbar-user' aria-label='Profile'>
          <div className='topbar-user-meta'>
            <span className='topbar-user-name'>{fullName}</span>
            <span className='topbar-user-role'>{isMerchant ? 'Merchant' : (isAdmin ? 'Admin' : 'Staff')}</span>
          </div>
          <span className='topbar-avatar' aria-hidden='true'>{initialsOf(firstName, lastName)}</span>
        </Link>
      </div>
    </header>
  );
}

export default Topbar;
